import { render } from "./segment.vue?vue&type=template&id=776e9e94"
import script from "./segment.vue?vue&type=script&lang=js"
export * from "./segment.vue?vue&type=script&lang=js"

import "./segment.vue?vue&type=style&index=0&id=776e9e94&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__